import firebaseApp from "./firebase";
import * as db from "./db";
import * as auth from "./auth";
import * as helpers from "./helpers";
import { dispatch } from "../recontext/store";

let UNSUPSCRIBLE_ME = null;
let UNSUPSCRIPLE_MY_TEAM_LIKERS = null;
let MY_TEAM_ID = null;

db.teamsRef.onSnapshot(helpers.updateTeams);
db.teamMatchingsRef.onSnapshot(helpers.updateTeamLikers);

const startSubscribleMyTeam = teamId => {
  if (MY_TEAM_ID && MY_TEAM_ID === teamId) return;
  if (MY_TEAM_ID && MY_TEAM_ID !== teamId)
    dispatch("SHOW_NOTIFICATION", {
      message: "Congrats! You got a Team!",
      type: "success"
    });

  if (UNSUPSCRIPLE_MY_TEAM_LIKERS) UNSUPSCRIPLE_MY_TEAM_LIKERS();
  MY_TEAM_ID = teamId;
  UNSUPSCRIPLE_MY_TEAM_LIKERS = db.teamMatchingsRef
    .doc(teamId)
    .onSnapshot(doc => {
      doc &&
        doc.data() &&
        doc.data().likers &&
        doc.data().likers.length > 0 &&
        dispatch("SHOW_NOTIFICATION", {
          message: "You've got a new Team up request!",
          type: "info"
        });
    });
};

const startSubscribleMe = userId => {
  if (UNSUPSCRIBLE_ME) return;
  UNSUPSCRIBLE_ME = db.usersRef.doc(userId).onSnapshot(doc => {
    const user = doc.data();
    helpers.updateMe(user);
    startSubscribleMyTeam(user.teamId);
  });
};

export const login = () => {
  const provider = auth.facebookOAuth();
  return auth.getAuth().signInWithPopup(provider);
};

export const logout = () => {
  localStorage.clear();
  firebaseApp
    .auth()
    .signOut()
    .then(() => {
      window.location.reload();
    });
};

export const getTeams = () =>
  new Promise(resolve => {
    db.teamsRef
      .get()
      .then(snapshot => {
        helpers.updateTeams(snapshot);
        return db.teamMatchingsRef.get().then(snapshotLikers => {
          helpers.updateTeamLikers(snapshotLikers);
          return resolve(true);
        });
      })
      .catch(error => helpers.catchError(error, resolve));
  });

export const getMe = () =>
  new Promise(resolve => {
    firebaseApp.auth().onAuthStateChanged(user => {
      if (!user) return resolve(false);
      firebaseApp
        .functions()
        .httpsCallable("me")()
        .then(doc => {
          const user = doc.data;
          if (user && user.id) {
            helpers.updateMe(user);
            startSubscribleMe(user.id);
            return resolve(true);
          }
          return resolve(false);
        })
        .catch(error => helpers.catchError(error, resolve));
    });
  });

export const updateMe = (user, { displayName, intro, lookingFor }) =>
  new Promise(resolve => {
    const changes = {};
    if (user.displayName !== displayName) changes.displayName = displayName;
    if (user.intro !== intro) changes.intro = intro;
    if (user.lookingFor !== lookingFor) changes.lookingFor = lookingFor;
    if (Object.keys(changes).length === 0) {
      resolve(true);
      return;
    }

    firebaseApp
      .functions()
      .httpsCallable("updateMe")({ changes })
      .then(() => {
        localStorage.setItem(
          "USER_DATA",
          JSON.stringify({
            ...user,
            ...changes
          })
        );
        dispatch("UPDATE_USER", {
          user: changes
        });
        return resolve(true);
      })
      .catch(error => helpers.catchError(error, resolve));
  });

export const likeTeam = teamId =>
  new Promise(resolve => {
    firebaseApp
      .functions()
      .httpsCallable("doLikeTeam")({ teamId })
      .then(doc => {
        dispatch("UPDATE_TEAM_LIKERS", { teamId, newLikers: doc.data });
        console.log(doc);
        return resolve(true);
      })
      .catch(error => helpers.catchError(error, resolve));
  });

export const acceptLiker = likerId =>
  new Promise(resolve => {
    firebaseApp
      .functions()
      .httpsCallable("doAcceptLiker")({ likerId })
      .then(() => {
        dispatch("MOVE_TEAM", { likerId });
        return resolve(true);
      })
      .catch(error => helpers.catchError(error, resolve));
  });

export const leftTeam = () =>
  new Promise(resolve => {
    firebaseApp
      .functions()
      .httpsCallable("leftTeam")()
      .then(() => {
        dispatch("LEFT_TEAM");
        return resolve(true);
      })
      .catch(error => helpers.catchError(error, resolve));
  });

export const updateTeamInfo = (myTeam, { name, intro, track }) =>
  new Promise(resolve => {
    const changes = {};
    if (myTeam.name !== name) changes.name = name;
    if (myTeam.intro !== intro) changes.intro = intro;
    if (myTeam.track !== track) changes.track = track;
    if (Object.keys(changes).length === 0) {
      return resolve(true);
    }
    firebaseApp
      .functions()
      .httpsCallable("updateTeamInfo")({
        teamId: myTeam.id,
        changes
      })
      .then(() => {
        dispatch("UPDATE_TEAM", { teamId: myTeam.id, changes });
        return resolve(true);
      })
      .catch(error => helpers.catchError(error, resolve));
  });
